<template>
  <div class="bi-publico">
    <header class="hero card">
      <div>
        <p class="eyebrow">BI Público • Gestão de Projetos</p>
        <h1>Árvore de execução <span>PDM</span></h1>
        <p>
          Navegue por Unidade Regional → Município → Plano → Projeto → Ações →
          Entregas → Tarefas com visual consolidado e expandido.
        </p>
      </div>
      <button class="btn" @click="carregarTudo" :disabled="carregando">
        {{ carregando ? "Atualizando..." : "Atualizar BI" }}
      </button>
    </header>

    <section class="filtros card">
      <div class="campo">
        <label>Unidade Regional</label>
        <select v-model.number="filtros.idUnidadeRegional">
          <option :value="null">Todas</option>
          <option v-for="ur in unidadesRegionais" :key="ur.id" :value="ur.id">{{ ur.nome }}</option>
        </select>
      </div>
      <div class="campo">
        <label>Município</label>
        <select v-model.number="filtros.idMunicipio">
          <option :value="null">Todos</option>
          <option v-for="municipio in municipiosFiltrados" :key="municipio.id" :value="municipio.id">{{ municipio.nome }}</option>
        </select>
      </div>
      <div class="campo" v-if="filtros.idMunicipio">
        <label>Plano (PDM)</label>
        <select v-model.number="filtros.idPdm">
          <option :value="null">Selecione</option>
          <option v-for="pdm in pdmsFiltrados" :key="pdm.idPdm" :value="pdm.idPdm">{{ pdm.nome }}</option>
        </select>
      </div>
      <div class="campo" v-if="filtros.idPdm">
        <label>Projeto</label>
        <select v-model.number="filtros.idProjeto">
          <option :value="null">Selecione</option>
          <option v-for="projeto in projetosDoPdm" :key="projeto.idProjeto" :value="projeto.idProjeto">{{ projeto.titulo }}</option>
        </select>
      </div>
      <div class="campo" v-if="filtros.idProjeto">
        <label>Ação</label>
        <select v-model.number="filtros.idAcao">
          <option :value="null">Selecione</option>
          <option v-for="acao in acoesProjeto" :key="acao.idAcao" :value="acao.idAcao">{{ acao.titulo }}</option>
        </select>
      </div>
      <div class="campo" v-if="filtros.idAcao">
        <label>Entrega</label>
        <select v-model.number="filtros.idEntrega">
          <option :value="null">Selecione</option>
          <option v-for="entrega in entregasAcao" :key="entrega.idEntrega || entrega.idAcao" :value="entrega.idEntrega">{{ entrega.titulo }}</option>
        </select>
      </div>
      <div class="campo" v-if="filtros.idEntrega">
        <label>Tarefa</label>
        <select v-model.number="filtros.idTarefa">
          <option :value="null">Selecione</option>
          <option v-for="tarefa in tarefasEntrega" :key="tarefa.idTarefa" :value="tarefa.idTarefa">{{ tarefa.titulo }}</option>
        </select>
      </div>
    </section>

    <section class="cards">
      <article class="card kpi"><span>PDMs</span><strong>{{ pdmsFiltrados.length }}</strong></article>
      <article class="card kpi"><span>Projetos</span><strong>{{ projetosNoEscopo.length }}</strong></article>
      <article class="card kpi"><span>Ações</span><strong>{{ totalAcoes }}</strong></article>
      <article class="card kpi"><span>Métricas</span><strong>{{ totalMetricas }}</strong></article>
      <article class="card kpi"><span>Execução Média</span><strong>{{ execucaoMedia }}%</strong></article>
      <article class="card kpi"><span>OKRs PDM</span><strong>{{ okrMedioEscopo }}%</strong></article>
    </section>

    <section class="insights-grid">
      <article class="card painel-status">
        <header><h3>Distribuição por status</h3></header>
        <div class="status-lista">
          <div v-for="item in statusResumo" :key="item.rotulo" class="status-item">
            <p>{{ item.rotulo }}</p>
            <strong>{{ item.quantidade }}</strong>
            <small>{{ item.percentual }}%</small>
            <div class="status-leitura">
              <span>Saúde: {{ item.saudeResumo }}</span>
              <span>Prioridade alta/crítica: {{ item.prioridadeAltaCritica }}</span>
              <span>Prazo: {{ item.prazoResumo }}</span>
            </div>
          </div>
        </div>
      </article>
      <article class="card painel-eixos" v-if="areasDoPdmSelecionado.length">
        <header><h3>Metas por Áreas Chave</h3></header>
        <div class="eixo-item" v-for="area in areasDoPdmSelecionado" :key="area.nome">
          <button class="btn-area-kpi" @click="selecionarAreaKpi(area)">
            <div class="eixo-head">
              <span>{{ area.nome }}</span>
              <span>{{ area.execucao }}%</span>
            </div>
            <div class="barra"><span :style="{ width: `${area.execucao}%` }"></span></div>
            <small>{{ area.qtdProjetos }} projeto(s) • {{ (area.objetivosOkr || []).length }} objetivo(s)</small>
          </button>

          <div v-if="areaKpiSelecionada && areaKpiSelecionada.nome === area.nome" class="okr-detalhe">
            <h4>Objetivos cadastrados: {{ area.nome }}</h4>
            <div v-if="!(area.objetivosOkr || []).length" class="okr-vazio">Sem objetivos cadastrados para esta área.</div>
            <div v-for="objetivo in area.objetivosOkr || []" :key="objetivo.idObjetivo || obterTituloObjetivo(objetivo)" class="objetivo-item">
              <button class="btn-objetivo" @click="selecionarObjetivoKpi(objetivo)">
                {{ obterTituloObjetivo(objetivo) }}
              </button>
              <ul v-if="objetivoKpiSelecionado && chaveObjetivo(objetivoKpiSelecionado) === chaveObjetivo(objetivo)" class="kr-lista">
                <li v-for="resultado in objetivo.resultados || []" :key="resultado.idResultado || obterTituloKr(resultado)">
                  <strong>{{ obterTituloKr(resultado) }}</strong>
                  <span>Mensuração atual: {{ obterMensuracaoKr(resultado) }}</span>
                </li>
                <li v-if="!(objetivo.resultados || []).length">Nenhum KR cadastrado.</li>
              </ul>
            </div>
          </div>
        </div>
      </article>
    </section>


    <section class="card painel-gantt">
      <div class="gantt-head">
        <h3>Cronograma de Projetos (Gantt)</h3>
        <button class="btn" @click="exibirGantt = !exibirGantt">
          {{ exibirGantt ? "Ocultar" : "Exibir" }} Gantt
        </button>
      </div>
      <div v-if="exibirGantt" class="gantt-wrap">
        <div class="gantt-row" v-for="item in projetosGantt" :key="`gantt-${item.idProjeto}`">
          <div class="gantt-label">
            <strong>{{ item.titulo }}</strong>
            <small>{{ formatarData(item.inicio) }} → {{ formatarData(item.fim) }}</small>
          </div>
          <div class="gantt-track">
            <div class="gantt-bar" :class="item.classe" :style="{ left: `${item.left}%`, width: `${item.width}%` }">
              {{ item.rotuloStatus }}
            </div>
          </div>
          <div class="gantt-alerta" v-if="item.divergente">⚠ {{ item.divergenciaTexto }}</div>
        </div>
        <p v-if="!projetosGantt.length" class="okr-vazio">Sem projetos com período definido para exibir no Gantt.</p>
      </div>
    </section>

    <section class="bi-quadro card">
      <header>
        <h2>Portfólio PDM por Unidade Regional</h2>
        <div class="acoes">
          <label v-for="col in colunasPdmDisponiveis" :key="col.key">
            <input type="checkbox" v-model="colunasPdmSelecionadas" :value="col.key" />
            {{ col.label }}
          </label>
          <button class="btn" @click="exportarXlsPdm">XLS</button>
          <button class="btn" @click="exportarXlsDetalhado" :disabled="carregando">XLS detalhado</button>
          <button class="btn" @click="modalPdfAberto = true">PDF</button>
        </div>
      </header>

      <div class="tabela-wrap">
        <table>
          <thead><tr><th v-for="col in colunasPdmAtivas" :key="col.key">{{ col.label }}</th></tr></thead>
          <tbody>
            <tr v-for="pdm in pdmsFiltrados" :key="`pdm-${pdm.idPdm}`" class="linha-pdm"
              :class="{ selecionada: pdmSelecionado && pdmSelecionado.idPdm === pdm.idPdm }" @click="selecionarPdm(pdm)">
              <td v-for="col in colunasPdmAtivas" :key="`pdm-${pdm.idPdm}-${col.key}`">
                <span v-if="col.key === 'pdm'"><strong>{{ pdmSelecionado && pdmSelecionado.idPdm === pdm.idPdm ? '● ' : '' }}</strong>{{ valorColunaPdm(pdm, col.key) }}</span>
                <span v-else-if="col.key === 'areasChave'">Áreas-chave: {{ obterResumoAreasChave(pdm.idPdm).length }}</span>
                <span v-else>{{ valorColunaPdm(pdm, col.key) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section v-if="pdmSelecionado" class="bloco-projetos card">
      <h3>PDM selecionado: {{ pdmSelecionado.nome }}</h3>
      <div v-for="area in areasDoPdmSelecionado" :key="`area-${pdmSelecionado.idPdm}-${area.nome}`" class="area-box"
        :class="{ selecionada: areaSelecionada && areaSelecionada.nome === area.nome }" @click="selecionarArea(pdmSelecionado, area)">
        <h4>{{ areaSelecionada && areaSelecionada.nome === area.nome ? '◆' : '◇' }} {{ area.nome }}</h4>
        <p>Projetos: {{ area.qtdProjetos }} • Execução: {{ area.execucao }}%</p>
        <ul>
          <li v-for="projeto in area.projetos" :key="projeto.idProjeto">
            <button class="link" :class="{ marcado: projetoDetalhe && projetoDetalhe.idProjeto === projeto.idProjeto }" @click.stop="abrirProjeto(projeto.idProjeto)">
              {{ projetoDetalhe && projetoDetalhe.idProjeto === projeto.idProjeto ? '▶ ' : '' }}{{ projeto.titulo }}
            </button>

            <section v-if="projetoDetalhe && projetoDetalhe.idProjeto === projeto.idProjeto" class="bloco-projeto-detalhe card bloco-projeto-inline">
              <h3>1 {{ projetoDetalhe.titulo }}</h3>
              <div class="tabela-wrap">
                <table>
                  <thead><tr><th>Projeto</th><th>Início</th><th>Fim</th><th>Prioridade</th><th>Situação</th><th>Saúde</th></tr></thead>
                  <tbody><tr><td>{{ projetoDetalhe.titulo }}</td><td>{{ formatarData(projetoDetalhe.dataInicio) }}</td><td>{{ formatarData(projetoDetalhe.dataFim) }}</td><td>{{ projetoDetalhe.prioridade || "-" }}</td><td>{{ projetoDetalhe.situacao || "-" }}</td><td>{{ projetoDetalhe.nivelSaude || "-" }}</td></tr></tbody>
                </table>
              </div>
              <div class="grupo-botoes">
                <button class="btn" :class="{ ativo: abaProjeto === 'equipes' }" @click="abaProjeto = 'equipes'">Equipe</button>
                <button class="btn" :class="{ ativo: abaProjeto === 'orcamentos' }" @click="abaProjeto = 'orcamentos'">Orçamento</button>
                <button class="btn" :class="{ ativo: abaProjeto === 'metricas' }" @click="abaProjeto = 'metricas'">Métricas</button>
                <button class="btn" :class="{ ativo: abaProjeto === 'acoes' }" @click="abaProjeto = 'acoes'">Ações</button>
              </div>

              <div v-if="abaProjeto === 'equipes'" class="painel-aba">
                <p v-if="!(projetoDetalhe.equipes || []).length">Sem equipe cadastrada.</p>
                <ul v-if="(projetoDetalhe.equipes || []).length"><li v-for="item in projetoDetalhe.equipes" :key="item.idEquipe">{{ item.nome }}</li></ul>
                <p v-else>Sem registros</p>
              </div>
              <div v-if="abaProjeto === 'orcamentos'" class="painel-aba">
                <p v-if="!(projetoDetalhe.orcamentos || []).length">Sem orçamento cadastrado.</p>
                <ul v-if="(projetoDetalhe.orcamentos || []).length"><li v-for="item in projetoDetalhe.orcamentos" :key="item.idOrcamento">{{ item.categoria || "Categoria" }}: {{ moeda(item.valorPlanejado || 0) }} / {{ moeda(item.valorExecutado || 0) }}</li></ul>
                <p v-else>Sem registros</p>
              </div>
              <div v-if="abaProjeto === 'metricas'" class="painel-aba">
                <p v-if="!(projetoDetalhe.metricas || []).length">Sem métricas cadastradas.</p>
                <ul v-if="metricasCorrelacionadas.length"><li v-for="m in metricasCorrelacionadas" :key="m.idMetrica">{{ m.nome }} ({{ m.valorAtual || 0 }}/{{ m.meta || 0 }}) • Ações vinculadas: {{ m.acoesLigadas.join(", ") || "Nenhuma" }}</li></ul>
                <p v-else>Sem registros</p>
              </div>
              <div v-if="abaProjeto === 'acoes'" class="painel-aba">
                <p v-if="!acoesProjeto.length">Sem registros</p>
                <div
                  v-for="acao in acoesProjeto"
                  :key="acao.idAcao"
                  class="acao-card"
                  :class="{ selecionada: filtros.idAcao === acao.idAcao }"
                  @click="filtros.idAcao = acao.idAcao"
                >
                  <h4>{{ acao.titulo }} • {{ acao.progressoCalculado || acao.percentualConclusao || 0 }}%</h4>
                  <p>Métrica ligada: {{ metricaAcao(acao).join(", ") || "Não vinculada" }}</p>
                  <div v-if="(acao.entregas || []).length" class="entregas-lista">
                    <div
                      v-for="entrega in acao.entregas"
                      :key="entrega.idEntrega || entrega.idAcao"
                      class="entrega-publica"
                      :class="{ selecionada: filtros.idEntrega === entrega.idEntrega }"
                      @click.stop="filtros.idEntrega = entrega.idEntrega"
                    >
                      <strong>{{ entrega.titulo }} • {{ entrega.percentualConclusao || 0 }}%</strong>
                      <ul v-if="(entrega.tarefas || []).length">
                        <li
                          v-for="tarefa in entrega.tarefas"
                          :key="tarefa.idTarefa"
                          :class="{ selecionada: filtros.idTarefa === tarefa.idTarefa }"
                          @click.stop="filtros.idTarefa = tarefa.idTarefa"
                        >
                          {{ tarefa.titulo }} • {{ tarefa.percentualConclusao || 0 }}%
                        </li>
                      </ul>
                      <small v-else>Sem tarefas registradas.</small>
                    </div>
                  </div>
                  <p v-else class="okr-vazio">Sem entregas registradas para esta ação.</p>
                </div>
              </div>
            </section>
          </li>
        </ul>
      </div>
    </section>



    <section v-if="modalPdfAberto" class="modal-pdf-backdrop" @click.self="modalPdfAberto = false">
      <div class="modal-pdf">
        <h4>Exportação em PDF</h4>
        <p>Selecione o tipo de visualização:</p>
        <label class="radio"><input type="radio" value="consolidada" v-model="tipoPdfSelecionado" />Consolidada</label>
        <label class="radio"><input type="radio" value="expandida" v-model="tipoPdfSelecionado" />Expandida</label>
        <div class="modal-acoes">
          <button class="btn" @click="modalPdfAberto = false">Cancelar</button>
          <button class="btn ativo" @click="confirmarExportacaoPdf">Gerar PDF</button>
        </div>
      </div>
    </section>

    <p v-if="erro" class="erro">{{ erro }}</p>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
  calcularExecucaoProjetos,
  progressoOkrDosEixos,
  progressoOkrDosPdms,
} from "../utils/indicadoresPdm.mjs";
import {
  consolidarExecucaoMunicipioArea,
  criarWorkbookExecucaoMunicipioArea,
} from "../utils/exportacaoPdm.mjs";
import {
  buscarPdms,
  buscarProjetos,
  buscarProjeto,
  buscarPdmDetalhe,
  buscarProjetosDetalhesLote,
  buscarUnidadesRegionaisPublicas,
  buscarMunicipiosPublicos,
} from "../services/api";

export default {
  name: "PainelPublicoGestaoProjetos",
  data() {
    return {
      carregando: false,
      erro: "",
      unidadesRegionais: [],
      municipios: [],
      pdms: [],
      pdmDetalhes: {},
      projetos: [],
      projetoDetalhe: null,
      projetoDetalhesCache: {},
      modalPdfAberto: false,
      tipoPdfSelecionado: "consolidada",
      filtros: {
        idUnidadeRegional: null,
        idMunicipio: null,
        idPdm: null,
        idProjeto: null,
        idAcao: null,
        idEntrega: null,
        idTarefa: null,
      },
      areaSelecionada: null,
      areaKpiSelecionadaNome: null,
      objetivoKpiSelecionadoChave: null,
      exibirGantt: false,
      abaProjeto: "acoes",
      colunasPdmDisponiveis: [
        { key: "pdm", label: "PDM" },
        { key: "status", label: "Status" },
        { key: "inicio", label: "Início" },
        { key: "fim", label: "Fim" },
        { key: "areasChave", label: "Áreas-chave" },
        { key: "qtdProjetos", label: "Qtd. Projetos" },
        { key: "execucao", label: "% Execução" },
        { key: "okr", label: "% OKRs" },
      ],
      colunasPdmSelecionadas: ["pdm", "status", "inicio", "fim", "areasChave", "qtdProjetos", "execucao", "okr"],
      situacoesGestaoProjetos: ["Ideacao", "Planejamento", "Execucao", "Monitoramento", "Concluido", "EmEspera", "Cancelado"],
    };
  },
  computed: {
    municipiosFiltrados() {
      if (!this.filtros.idUnidadeRegional) return this.municipios;
      return this.municipios.filter((m) => m.idUnidadeRegional === this.filtros.idUnidadeRegional);
    },
    pdmsFiltrados() {
      return this.pdms.filter((pdm) => {
        if (this.filtros.idUnidadeRegional) {
          const municipio = this.municipios.find((m) => m.id === pdm.idMunicipio);
          if (!municipio || municipio.idUnidadeRegional !== this.filtros.idUnidadeRegional) return false;
        }
        if (this.filtros.idMunicipio && pdm.idMunicipio !== this.filtros.idMunicipio) return false;
        return true;
      });
    },
    projetosBaseFiltro() {
      return this.projetos.filter((projeto) => {
        if (this.filtros.idUnidadeRegional) {
          const municipio = this.municipios.find((m) => m.id === projeto.idMunicipio);
          if (!municipio || municipio.idUnidadeRegional !== this.filtros.idUnidadeRegional) return false;
        }
        if (this.filtros.idMunicipio && projeto.idMunicipio !== this.filtros.idMunicipio) return false;
        return true;
      });
    },
    projetosNoEscopo() {
      return this.projetosBaseFiltro.filter((projeto) => {
        if (this.filtros.idPdm && projeto.idPdm !== this.filtros.idPdm) return false;
        if (this.filtros.idProjeto && projeto.idProjeto !== this.filtros.idProjeto) return false;
        return true;
      });
    },
    projetosDoPdm() {
      return this.projetosBaseFiltro.filter((item) => item.idPdm === this.filtros.idPdm);
    },
    acoesProjeto() {
      return this.normalizarAcoesProjeto(this.projetoDetalhe);
    },
    entregasAcao() {
      const acao = this.acoesProjeto.find((item) => item.idAcao === this.filtros.idAcao);
      return acao?.entregas || [];
    },
    tarefasEntrega() {
      const entrega = this.entregasAcao.find((item) => item.idEntrega === this.filtros.idEntrega);
      return entrega?.tarefas || [];
    },
    totalAcoes() {
      return this.projetosNoEscopo.length
        ? this.projetosNoEscopo.reduce((acc, p) => acc + this.totalAcoesProjeto(p), 0)
        : 0;
    },
    totalMetricas() {
      return this.projetosNoEscopo.reduce((acc, projeto) => {
        const detalhe = this.detalheProjeto(projeto);
        return acc + ((detalhe?.metricas || []).length || Number(projeto?.totalMetricas || 0));
      }, 0);
    },
    execucaoMedia() {
      if (!this.projetosNoEscopo.length) return 0;
      const soma = this.projetosNoEscopo.reduce((acc, p) => acc + this.execucaoProjeto(p), 0);
      return Math.round(soma / this.projetosNoEscopo.length);
    },
    okrMedioEscopo() {
      if (!this.pdmsFiltrados.length) return 0;
      const pdms = this.filtros.idPdm
        ? this.pdmsFiltrados.filter((pdm) => Number(pdm.idPdm) === Number(this.filtros.idPdm))
        : this.pdmsFiltrados;
      return progressoOkrDosPdms(pdms, this.pdmDetalhes);
    },
    colunasPdmAtivas() {
      return this.colunasPdmDisponiveis.filter((c) => this.colunasPdmSelecionadas.includes(c.key));
    },
    metricasCorrelacionadas() {
      const metricas = this.projetoDetalhe?.metricas || [];
      return metricas.map((metrica) => ({
        ...metrica,
        acoesLigadas: this.acoesProjeto
          .filter((acao) => this.metricaAcao(acao).includes(metrica.nome))
          .map((acao) => acao.titulo),
      }));
    },
    pdmSelecionado() {
      if (this.filtros.idPdm) {
        return this.pdmsFiltrados.find((pdm) => pdm.idPdm === this.filtros.idPdm) || null;
      }
      return this.pdmsFiltrados[0] || null;
    },
    areasDoPdmSelecionado() {
      if (!this.pdmSelecionado) return [];
      return this.obterResumoAreasChave(this.pdmSelecionado.idPdm);
    },
    areaKpiSelecionada() {
      return this.areasDoPdmSelecionado.find((area) => area.nome === this.areaKpiSelecionadaNome) || null;
    },
    objetivoKpiSelecionado() {
      const objetivos = this.areaKpiSelecionada?.objetivosOkr || [];
      return objetivos.find((objetivo) => this.chaveObjetivo(objetivo) === this.objetivoKpiSelecionadoChave) || null;
    },
    projetosGantt() {
      const projetosComDatas = this.projetosNoEscopo
        .map((projeto) => {
          const inicio = this.parseDate(projeto.dataInicio || projeto.periodoInicio || projeto.inicioPrevisto);
          const fim = this.parseDate(projeto.dataFim || projeto.periodoFim || projeto.fimPrevisto);
          return { ...projeto, inicio, fim };
        })
        .filter((projeto) => projeto.inicio && projeto.fim && projeto.fim >= projeto.inicio);

      if (!projetosComDatas.length) return [];

      const minInicio = Math.min(...projetosComDatas.map((projeto) => projeto.inicio.getTime()));
      const maxFim = Math.max(...projetosComDatas.map((projeto) => projeto.fim.getTime()));
      const range = Math.max(maxFim - minInicio, 86400000);

      return projetosComDatas.map((projeto) => {
        const left = ((projeto.inicio.getTime() - minInicio) / range) * 100;
        const width = Math.max(((projeto.fim.getTime() - projeto.inicio.getTime()) / range) * 100, 4);
        const timeline = this.statusProjetoPorData(projeto.inicio, projeto.fim);
        const divergencia = this.avaliarDivergenciaStatus(projeto, timeline.fase);

        return {
          ...projeto,
          left,
          width,
          classe: timeline.classe,
          rotuloStatus: timeline.rotulo,
          divergente: divergencia.divergente,
          divergenciaTexto: divergencia.texto,
        };
      });
    },
    statusResumo() {
      const projetos = this.projetosNoEscopo;
      const total = projetos.length || 1;
      const grupos = this.situacoesGestaoProjetos.map((situacao) => ({
        situacao,
        projetos: [],
      }));
      const gruposPorChave = grupos.reduce((acc, grupo) => {
        acc[this.chaveOpcaoProjeto(grupo.situacao)] = grupo;
        return acc;
      }, {});

      projetos.forEach((projeto) => {
        const chave = this.chaveOpcaoProjeto(this.obterSituacaoProjeto(projeto));
        if (gruposPorChave[chave]) {
          gruposPorChave[chave].projetos.push(projeto);
        }
      });

      return grupos.map((grupo) => {
        const quantidade = grupo.projetos.length;
        return {
          rotulo: this.formatarSituacaoProjeto(grupo.situacao),
          quantidade,
          percentual: Math.round((quantidade / total) * 100),
          ...this.leituraProjetosPorSituacao(grupo.projetos),
        };
      });
    },
  },
  watch: {
    "filtros.idUnidadeRegional"() {
      this.filtros.idMunicipio = null;
      this.resetarArvore();
    },
    async "filtros.idMunicipio"() {
      this.filtros.idPdm = null;
      this.resetarArvore();
    },
    "filtros.idPdm"() {
      this.filtros.idProjeto = null;
      this.filtros.idAcao = null;
      this.filtros.idEntrega = null;
      this.filtros.idTarefa = null;
      this.projetoDetalhe = null;
      this.areaSelecionada = null;
      this.areaKpiSelecionadaNome = null;
      this.objetivoKpiSelecionadoChave = null;
    },
    async "filtros.idProjeto"(id) {
      this.filtros.idAcao = null;
      this.filtros.idEntrega = null;
      this.filtros.idTarefa = null;
      if (!id) {
        this.projetoDetalhe = null;
        return;
      }
      await this.abrirProjeto(id);
    },
    "filtros.idAcao"() {
      this.filtros.idEntrega = null;
      this.filtros.idTarefa = null;
    },
    "filtros.idEntrega"() {
      this.filtros.idTarefa = null;
    },
  },
  async created() {
    await this.carregarTudo();
  },
  methods: {
    async carregarTudo() {
      try {
        this.carregando = true;
        this.erro = "";
        const [ursResp, municipiosResp, pdmsResp, projetosResp] = await Promise.all([
          buscarUnidadesRegionaisPublicas(),
          buscarMunicipiosPublicos(),
          buscarPdms(),
          buscarProjetos(),
        ]);

        this.unidadesRegionais = (ursResp.data || []).map((item) => ({
          id: Number(item.id_unidade_regional),
          nome: item.nomeRegiao,
        }));

        this.municipios = (municipiosResp.data || []).map((item) => ({
          id: Number(item.municipioId),
          nome: item.nome,
          idUnidadeRegional: Number(item.id_unidade_regional || 0),
        }));

        this.pdms = pdmsResp.data || [];

        const detalhes = await Promise.all(
          this.pdms.map(async (pdm) => {
            try {
              const { data } = await buscarPdmDetalhe(pdm.idPdm);
              return [pdm.idPdm, data];
            } catch (error) {
              return [pdm.idPdm, null];
            }
          })
        );
        this.pdmDetalhes = Object.fromEntries(detalhes);

        this.projetos = (projetosResp.data || []).map((p) => ({
          ...p,
          totalAcoes: Number(p.totalAcoes || 0),
          percentualExecucao: Number(p.percentualExecucao || 0),
        }));

        await this.precarregarDetalhesProjetos(this.projetos.map((p) => p.idProjeto));
      } catch (error) {
        this.erro = "Não foi possível carregar o BI. Mostrando dados demonstrativos.";
        this.carregarMock();
      } finally {
        this.carregando = false;
      }
    },
    resetarArvore() {
      this.filtros.idPdm = null;
      this.filtros.idProjeto = null;
      this.filtros.idAcao = null;
      this.filtros.idEntrega = null;
      this.filtros.idTarefa = null;
      this.areaSelecionada = null;
      this.areaKpiSelecionadaNome = null;
      this.objetivoKpiSelecionadoChave = null;
      this.projetoDetalhe = null;
    },
    normalizarNumero(valor) {
      const numero = Number(valor);
      return Number.isFinite(numero) ? numero : 0;
    },
    limitarPercentual(valor) {
      return Math.max(0, Math.min(100, Math.round(this.normalizarNumero(valor))));
    },
    mediaPercentual(valores) {
      const validos = valores
        .map((valor) => Number(valor))
        .filter((valor) => Number.isFinite(valor));
      if (!validos.length) return 0;
      return validos.reduce((acc, valor) => acc + valor, 0) / validos.length;
    },
    detalheProjeto(projeto) {
      if (!projeto?.idProjeto) return projeto || null;
      return this.projetoDetalhesCache[projeto.idProjeto] || projeto;
    },
    totalAcoesProjeto(projeto) {
      const detalhe = this.detalheProjeto(projeto);
      const totalDetalhe = this.normalizarAcoesProjeto(detalhe).length;
      return totalDetalhe || Number(projeto?.totalAcoes || 0);
    },
    execucaoProjeto(projeto) {
      const detalhe = this.detalheProjeto(projeto);
      const acoes = this.normalizarAcoesProjeto(detalhe);
      if (acoes.length) {
        return this.limitarPercentual(this.mediaPercentual(acoes.map((acao) => acao.progressoCalculado ?? acao.percentualConclusao)));
      }

      if (Number.isFinite(Number(projeto?.percentualExecucao)) && Number(projeto.percentualExecucao) > 0) {
        return this.limitarPercentual(projeto.percentualExecucao);
      }

      if (projeto?.orcamentoPlanejado) {
        return this.limitarPercentual(((projeto.orcamentoExecutado || 0) / projeto.orcamentoPlanejado) * 100);
      }
      return 0;
    },
    valorColunaPdm(pdm, coluna) {
      const projetos = this.projetosBaseFiltro.filter((p) => p.idPdm === pdm.idPdm);
      if (coluna === "pdm") return pdm.nome;
      if (coluna === "status") return pdm.status || "-";
      if (coluna === "inicio") return this.formatarData(pdm.periodoInicio);
      if (coluna === "fim") return this.formatarData(pdm.periodoFim);
      if (coluna === "qtdProjetos") return projetos.length;
      if (coluna === "execucao") {
        if (!projetos.length) return "0%";
        return `${Math.round(projetos.reduce((acc, p) => acc + this.execucaoProjeto(p), 0) / projetos.length)}%`;
      }
      if (coluna === "okr") {
        return `${Math.round(this.progressoOkrPdm(pdm.idPdm))}%`;
      }
      return "-";
    },
    progressoOkrPdm(idPdm) {
      const detalhePdm = this.pdmDetalhes[idPdm];
      return progressoOkrDosEixos(detalhePdm?.eixos || []);
    },
    obterResumoAreasChave(idPdm) {
      const detalhePdm = this.pdmDetalhes[idPdm];
      const eixos = detalhePdm?.eixos || [];
      const projetosNoPdm = this.projetosBaseFiltro.filter((p) => p.idPdm === idPdm);
      const projetosPorId = Object.fromEntries(
        projetosNoPdm.map((projeto) => [projeto.idProjeto, projeto])
      );

      if (!eixos.length) {
        return [];
      }

      return eixos.map((eixo) => {
        const idsVinculados = new Set((eixo.projetos || []).map((vinculo) => Number(vinculo.idProjeto)));
        const idEixo = Number(eixo.idEixo || eixo.id || eixo.projectStrategicAxisId);
        const projetosEixo = projetosNoPdm
          .filter((projeto) => {
            if (idsVinculados.has(Number(projeto.idProjeto))) return true;
            return (projeto.idsEixosPdm || []).map(Number).includes(idEixo);
          })
          .map((projeto) => projetosPorId[projeto.idProjeto])
          .filter(Boolean);

        return {
          nome: eixo.nome,
          projetos: projetosEixo,
          objetivosOkr: eixo.objetivosOkr || [],
          qtdProjetos: projetosEixo.length,
          execucao: calcularExecucaoProjetos(
            projetosEixo,
            (projeto) => this.execucaoProjeto(projeto)
          ),
        };
      });
    },

    obterTituloObjetivo(objetivo) {
      return (
        objetivo?.texto ||
        objetivo?.nome ||
        objetivo?.titulo ||
        objetivo?.descricao ||
        objetivo?.objetivo ||
        "Objetivo sem nome"
      );
    },
    chaveObjetivo(objetivo) {
      return objetivo?.idObjetivo || this.obterTituloObjetivo(objetivo);
    },
    obterTituloKr(resultado) {
      return (
        resultado?.texto ||
        resultado?.nome ||
        resultado?.titulo ||
        resultado?.descricao ||
        resultado?.resultado ||
        "KR sem descrição"
      );
    },
    selecionarAreaKpi(area) {
      if (!area) return;
      this.areaKpiSelecionadaNome = this.areaKpiSelecionadaNome === area.nome ? null : area.nome;
      this.objetivoKpiSelecionadoChave = null;
    },
    selecionarObjetivoKpi(objetivo) {
      const chave = this.chaveObjetivo(objetivo);
      this.objetivoKpiSelecionadoChave = this.objetivoKpiSelecionadoChave === chave ? null : chave;
    },
    obterMensuracaoKr(resultado) {
      if (!resultado) return "0%";
      if (Number.isFinite(Number(resultado.percentualAtingido))) {
        return `${Math.round(Number(resultado.percentualAtingido))}%`;
      }
      const valorAtual = Number(resultado.valorAtual);
      const meta = Number(resultado.meta);
      if (Number.isFinite(valorAtual) && Number.isFinite(meta) && meta > 0) {
        return `${valorAtual}/${meta} (${Math.round((valorAtual / meta) * 100)}%)`;
      }
      return "Sem mensuração";
    },
    parseDate(valor) {
      if (!valor) return null;
      const data = new Date(valor);
      return Number.isNaN(data.getTime()) ? null : data;
    },
    normalizarStatus(valor) {
      return String(valor || "")
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase();
    },
    chaveOpcaoProjeto(valor) {
      return this.normalizarStatus(valor).replace(/[^a-z0-9]/g, "");
    },
    obterSituacaoProjeto(projeto) {
      return projeto?.situacao || projeto?.status || "";
    },
    formatarSituacaoProjeto(valor) {
      const rotulos = {
        ideacao: "Ideação",
        planejamento: "Planejamento",
        execucao: "Execução",
        monitoramento: "Monitoramento",
        concluido: "Concluído",
        emespera: "Em espera",
        cancelado: "Cancelado",
      };
      return rotulos[this.chaveOpcaoProjeto(valor)] || valor || "-";
    },
    leituraProjetosPorSituacao(projetos = []) {
      const contarPorOpcao = (campo, opcoes) =>
        projetos.filter((projeto) => opcoes.includes(this.chaveOpcaoProjeto(projeto?.[campo]))).length;
      const saudavel = contarPorOpcao("nivelSaude", ["saudavel", "emdia"]);
      const atencao = contarPorOpcao("nivelSaude", ["atencao"]);
      const critico = contarPorOpcao("nivelSaude", ["critico"]);
      const prioridadeAltaCritica = contarPorOpcao("prioridade", ["alta", "critica"]);
      const vencidos = projetos.filter((projeto) => this.projetoComPrazoVencido(projeto)).length;
      const aIniciar = projetos.filter((projeto) => this.projetoAindaNaoIniciadoPorData(projeto)).length;

      return {
        saudeResumo: `${saudavel} saudável • ${atencao} atenção • ${critico} crítico`,
        prioridadeAltaCritica,
        prazoResumo: `${vencidos} vencido(s) • ${aIniciar} a iniciar`,
      };
    },
    projetoComPrazoVencido(projeto) {
      const fim = this.parseDate(projeto?.dataFim || projeto?.periodoFim || projeto?.fimPrevisto);
      if (!fim) return false;
      const status = this.chaveOpcaoProjeto(this.obterSituacaoProjeto(projeto));
      if (["concluido", "cancelado"].includes(status)) return false;
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      fim.setHours(0, 0, 0, 0);
      return fim < hoje;
    },
    projetoAindaNaoIniciadoPorData(projeto) {
      const inicio = this.parseDate(projeto?.dataInicio || projeto?.periodoInicio || projeto?.inicioPrevisto);
      if (!inicio) return false;
      const status = this.chaveOpcaoProjeto(this.obterSituacaoProjeto(projeto));
      if (["concluido", "cancelado"].includes(status)) return false;
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      inicio.setHours(0, 0, 0, 0);
      return inicio > hoje;
    },
    statusProjetoPorData(inicio, fim) {
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      if (hoje < inicio) return { fase: "planejado", classe: "planejado", rotulo: "Planejado" };
      if (hoje <= fim) return { fase: "execucao", classe: "execucao", rotulo: "Em execução" };
      return { fase: "concluido", classe: "concluido", rotulo: "Concluído" };
    },
    avaliarDivergenciaStatus(projeto, faseTimeline) {
      const status = this.normalizarStatus(projeto?.situacao || projeto?.status);
      const planejado = status.includes("planej");
      const finalizado = status.includes("final") || status.includes("conclu");

      if (faseTimeline === "execucao" && planejado) {
        return { divergente: true, texto: "Status divergente: data indica execução, mas status está planejado." };
      }
      if (faseTimeline === "concluido" && !finalizado) {
        return { divergente: true, texto: "Status divergente: data indica conclusão, mas status não está finalizado." };
      }
      return { divergente: false, texto: "" };
    },
    selecionarPdm(pdm) {
      if (!pdm) return;
      this.filtros.idPdm = pdm.idPdm;
      this.areaSelecionada = null;
      this.areaKpiSelecionadaNome = null;
      this.objetivoKpiSelecionadoChave = null;
    },
    selecionarArea(pdm, area) {
      this.areaSelecionada = {
        ...area,
        pdm,
      };
    },
    normalizarAcoesProjeto(detalhe) {
      if (!detalhe) return [];

      const entregasPorMarco = (detalhe.entregas || []).reduce((acc, entrega) => {
        const idMarco = entrega.idMarco ?? entrega.idAcao;
        if (!idMarco) return acc;
        if (!acc[idMarco]) acc[idMarco] = [];
        acc[idMarco].push({
          ...entrega,
          idEntrega: entrega.idEntrega ?? entrega.idAcao ?? null,
          tarefas: entrega.tarefas || [],
          percentualConclusao: this.limitarPercentual(
            entrega.percentualConclusao ?? entrega.progresso ?? this.mediaPercentual((entrega.tarefas || []).map((t) => t.percentualConclusao))
          ),
        });
        return acc;
      }, {});

      const marcos = (detalhe.marcos || []).map((marco) => ({
        ...marco,
        idAcao: marco.idMarco ?? null,
        entregas: entregasPorMarco[marco.idMarco] || [],
        tarefas: (entregasPorMarco[marco.idMarco] || []).flatMap((entrega) => entrega.tarefas || []),
      })).map((marco) => {
        const progressoCalculado = marco.entregas.length
          ? this.mediaPercentual(marco.entregas.map((entrega) => entrega.percentualConclusao))
          : this.mediaPercentual((marco.tarefas || []).map((tarefa) => tarefa.percentualConclusao));
        return {
          ...marco,
          progressoCalculado: this.limitarPercentual(progressoCalculado || marco.progresso || marco.percentualConclusao),
          percentualConclusao: this.limitarPercentual(marco.progresso ?? marco.percentualConclusao ?? progressoCalculado),
        };
      });

      if (marcos.length) return marcos;

      return (detalhe.entregas || []).map((entrega) => ({
        ...entrega,
        idAcao: entrega.idEntrega ?? entrega.idMarco ?? null,
        idEntrega: entrega.idEntrega ?? null,
        entregas: [entrega],
        tarefas: entrega.tarefas || [],
        progressoCalculado: this.limitarPercentual(entrega.percentualConclusao ?? entrega.progresso),
      }));
    },
    async abrirProjeto(idProjeto) {
      let data = this.projetoDetalhesCache[idProjeto];
      if (!data) {
        const resp = await buscarProjeto(idProjeto);
        data = resp.data;
        this.$set(this.projetoDetalhesCache, idProjeto, data);
        this.projetos = this.projetos.map((p) =>
          p.idProjeto === idProjeto
            ? { ...p, totalAcoes: this.normalizarAcoesProjeto(data).length }
            : p
        );
      }
      this.projetoDetalhe = data;
      this.abaProjeto = "acoes";
    },
    async precarregarDetalhesProjetos(idsProjetos = []) {
      const ids = idsProjetos.filter(Boolean);
      const faltantes = ids.filter((id) => !this.projetoDetalhesCache[id]);

      if (faltantes.length) {
        try {
          for (let i = 0; i < faltantes.length; i += 30) {
            const lote = faltantes.slice(i, i + 30);
            const { data } = await buscarProjetosDetalhesLote(lote);
            (data || []).forEach((detalhe) => {
              if (detalhe?.idProjeto) {
                this.$set(this.projetoDetalhesCache, detalhe.idProjeto, detalhe);
              }
            });
          }
        } catch (error) {
          // fallback: mantém cache atual sem bloquear fluxo
        }
      }

      this.projetos = this.projetos.map((projeto) => {
        const detalhe = this.projetoDetalhesCache[projeto.idProjeto];
        return {
          ...projeto,
          totalAcoes: this.normalizarAcoesProjeto(detalhe).length || projeto.totalAcoes || 0,
          percentualExecucao: detalhe ? this.execucaoProjeto(projeto) : projeto.percentualExecucao,
        };
      });
    },
    metricaAcao(acao) {
      const metricas = this.projetoDetalhe?.metricas || [];
      const vinculadas = this.nomesMetricasVinculadas(metricas, acao);
      if (vinculadas.length) return vinculadas;
      const texto = `${acao.titulo || ""} ${acao.descricao || ""}`.toLowerCase();
      return metricas
        .filter((m) => texto.includes(String(m.nome || "").toLowerCase()))
        .map((m) => m.nome);
    },
    metricaAcaoPorDetalhe(detalhe, acao) {
      const metricas = detalhe?.metricas || [];
      const vinculadas = this.nomesMetricasVinculadas(metricas, acao);
      if (vinculadas.length) return vinculadas;
      const texto = `${acao.titulo || ""} ${acao.descricao || ""}`.toLowerCase();
      return metricas
        .filter((m) => texto.includes(String(m.nome || "").toLowerCase()))
        .map((m) => m.nome);
    },
    nomesMetricasVinculadas(metricas = [], acao = {}) {
      const ids = new Set();
      const nomes = new Set();
      const adicionarReferencia = (referencia) => {
        if (referencia === null || referencia === undefined) return;
        if (typeof referencia === "object") {
          [
            referencia.idMetrica,
            referencia.__id,
            referencia.id,
            referencia.value,
            referencia.IdMetrica,
          ].forEach((valor) => {
            const numero = Number(valor);
            if (Number.isFinite(numero) && numero > 0) ids.add(numero);
          });
          const nome = String(referencia.nome || referencia.label || referencia.Nome || "").trim().toLowerCase();
          if (nome) nomes.add(nome);
          return;
        }
        const numero = Number(referencia);
        if (Number.isFinite(numero) && numero > 0) {
          ids.add(numero);
        } else {
          const nome = String(referencia).trim().toLowerCase();
          if (nome) nomes.add(nome);
        }
      };

      ["metricasIds", "metricasVinculadas", "metricas"].forEach((campo) => {
        const referencias = acao?.[campo];
        if (Array.isArray(referencias)) referencias.forEach(adicionarReferencia);
      });

      return metricas
        .filter((metrica) => {
          const id = Number(metrica.idMetrica ?? metrica.__id ?? metrica.id);
          const nome = String(metrica.nome || metrica.label || "").trim().toLowerCase();
          return ids.has(id) || nomes.has(nome);
        })
        .map((metrica) => metrica.nome)
        .filter(Boolean);
    },
    formatarData(valor) {
      if (!valor) return "-";
      const d = new Date(valor);
      if (Number.isNaN(d.getTime())) return "-";
      return d.toLocaleDateString("pt-BR");
    },
    moeda(valor) {
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(valor) || 0);
    },
    exportarXlsPdm() {
      const dados = this.pdmsFiltrados.map((pdm) => {
        const linha = {};
        this.colunasPdmAtivas.forEach((coluna) => {
          linha[coluna.label] =
            coluna.key === "areasChave"
              ? this.obterResumoAreasChave(pdm.idPdm).map((a) => a.nome).join(", ")
              : this.valorColunaPdm(pdm, coluna.key);
        });
        return linha;
      });
      const ws = XLSX.utils.json_to_sheet(dados);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "PDMs");
      XLSX.writeFile(wb, "bi-pdms.xlsx");
    },
    exportarXlsDetalhado() {
      if (this.carregando) return;
      const municipiosPorId = Object.fromEntries(
        this.municipios.map((municipio) => [Number(municipio.id), municipio])
      );
      const unidadesPorId = Object.fromEntries(
        this.unidadesRegionais.map((unidade) => [Number(unidade.id), unidade])
      );
      const registros = this.pdmsFiltrados.flatMap((pdm) => {
        const municipio = municipiosPorId[Number(pdm.idMunicipio)];
        const unidadeRegional = unidadesPorId[Number(municipio?.idUnidadeRegional)];

        return this.obterResumoAreasChave(pdm.idPdm).map((area) => ({
          idMunicipio: Number(pdm.idMunicipio),
          municipio: municipio?.nome,
          unidadeRegional: unidadeRegional?.nome,
          pdm: pdm.nome,
          area: area.nome,
          projetos: area.projetos.map((projeto) => ({
            ...projeto,
            acoes: this.normalizarAcoesProjeto(this.detalheProjeto(projeto)),
            totalAcoes: this.totalAcoesProjeto(projeto),
            execucao: this.execucaoProjeto(projeto),
          })),
        }));
      });
      const linhas = consolidarExecucaoMunicipioArea(registros);
      const wb = criarWorkbookExecucaoMunicipioArea(XLSX, linhas);
      XLSX.writeFile(wb, "bi-pdms-detalhado-municipio-area.xlsx");
    },
    confirmarExportacaoPdf() {
      if (String(this.tipoPdfSelecionado).toLowerCase().startsWith("exp")) {
        this.exportarPdfExpandido();
      } else {
        this.exportarPdfConsolidado();
      }
      this.modalPdfAberto = false;
    },
    exportarPdfConsolidado() {
      const pdf = new jsPDF("landscape", "pt", "a4");
      pdf.setFontSize(16);
      pdf.text("BI Gestão de Projetos - Visão Consolidada", 36, 30);
      pdf.setDrawColor(13, 59, 138);
      pdf.roundedRect(24, 18, 790, 34, 6, 6);
      autoTable(pdf, {
        startY: 60,
        head: [this.colunasPdmAtivas.map((c) => c.label)],
        body: this.pdmsFiltrados.map((pdm) =>
          this.colunasPdmAtivas.map((coluna) =>
            coluna.key === "areasChave"
              ? this.obterResumoAreasChave(pdm.idPdm).map((a) => a.nome).join(", ")
              : String(this.valorColunaPdm(pdm, coluna.key))
          )
        ),
        styles: { fontSize: 8, overflow: "linebreak", cellPadding: 4 },
        headStyles: { fillColor: [13, 59, 138], textColor: 255 },
        alternateRowStyles: { fillColor: [245, 248, 255] },
        theme: "grid",
      });
      pdf.save("bi-consolidado.pdf");
    },
    async exportarPdfExpandido() {
      const pdf = new jsPDF("portrait", "pt", "a4");
      pdf.setFontSize(20);
      pdf.text("Relatório Geral de Gestão de Projetos", 36, 80);
      pdf.setFontSize(12);
      pdf.text("Abordagem orientada ao PMBOK", 36, 102);
      pdf.text(`Gerado em ${new Date().toLocaleString("pt-BR")}`, 36, 122);

      pdf.addPage();
      let y = 36;

      const secoesPmbok = [
        ["Integração", "Alinhamento entre PDM, projetos e ações estratégicas."],
        ["Escopo", "Áreas-chave e objetivos priorizados por município e UR."],
        ["Cronograma", "Períodos planejados, marcos e status de execução."],
        ["Custos", "Relação entre orçamento planejado e executado."],
        ["Qualidade", "Indicadores de saúde, situação e aderência de entregáveis."],
        ["Recursos", "Equipe envolvida e capacidade operacional das frentes."],
        ["Comunicações", "Visão consolidada e expandida para stakeholders."],
        ["Riscos", "Sinalização de atrasos e pontos críticos por nível."],
        ["Aquisições", "Demandas de apoio e insumos dos planos/projetos."],
        ["Stakeholders", "Impacto em UR, municípios e patrocinadores do portfólio."],
      ];

      pdf.setFontSize(14);
      pdf.text("1) Estratégia de Gestão (PMBOK)", 36, y);
      y += 12;
      autoTable(pdf, {
        startY: y,
        head: [["Domínio", "Diretriz aplicada no relatório"]],
        body: secoesPmbok,
        styles: { fontSize: 9 },
      });

      y = pdf.lastAutoTable.finalY + 18;

      this.pdmsFiltrados.forEach((pdm, index) => {
        if (y > 680) {
          pdf.addPage();
          y = 40;
        }
        pdf.setFontSize(14);
        pdf.text(`2.${index + 1} PDM: ${pdm.nome}`, 36, y);
        y += 18;
        pdf.setFontSize(10);
        pdf.text(`Status: ${pdm.status || "-"} | Período: ${this.formatarData(pdm.periodoInicio)} - ${this.formatarData(pdm.periodoFim)}`, 36, y);
        y += 16;

        const projetos = this.projetosBaseFiltro.filter((p) => p.idPdm === pdm.idPdm);
        const areas = this.obterResumoAreasChave(pdm.idPdm).map((a) => [
          a.nome,
          String(a.qtdProjetos),
          `${a.execucao}%`,
        ]);

        if (areas.length) {
          autoTable(pdf, {
            startY: y,
            head: [["Área-chave", "Projetos", "Execução"]],
            body: areas,
            styles: { fontSize: 8 },
          });
          y = pdf.lastAutoTable.finalY + 10;
        }

        projetos.forEach((projeto) => {
          if (y > 690) {
            pdf.addPage();
            y = 40;
          }
          pdf.text(`• Projeto: ${projeto.titulo} | Execução: ${this.execucaoProjeto(projeto)}%`, 48, y);
          y += 14;
        });
        y += 8;
      });

      pdf.addPage();
      pdf.setFontSize(14);
      pdf.text("3) KPIs correlacionados às ações", 36, 40);
      const todosProjetos = this.projetosNoEscopo;
      await this.precarregarDetalhesProjetos(todosProjetos.map((p) => p.idProjeto));
      const detalhesProjetos = [];
      todosProjetos.forEach((projeto) => {
        const detalhe = this.projetoDetalhesCache[projeto.idProjeto];
        if (detalhe) detalhesProjetos.push(detalhe);
      });

      const linhas = detalhesProjetos.flatMap((detalhe) => (detalhe?.metricas || []).map((m) => [
        m.nome,
        `${m.valorAtual || 0}/${m.meta || 0}`,
        (this.normalizarAcoesProjeto(detalhe)
          .filter((a) => this.metricaAcaoPorDetalhe(detalhe, a).includes(m.nome))
          .map((a) => a.titulo).join(", ")) || "-",
      ]));
      autoTable(pdf, {
        startY: 56,
        head: [["KPI", "Atual/Meta", "Ações vinculadas"]],
        body: linhas,
        styles: { fontSize: 8, overflow: "linebreak" },
        theme: "grid",
      });

      detalhesProjetos.forEach((detalhe) => {
        pdf.addPage();
        pdf.setFontSize(13);
        pdf.text(`Projeto: ${detalhe.titulo}`, 36, 36);
        const linhasDetalhe = [
          ["Equipe", (detalhe.equipes || []).length ? detalhe.equipes.map((e) => e.nome).join(", ") : "Sem registros"],
          ["Orçamento", (detalhe.orcamentos || []).length ? detalhe.orcamentos.map((o) => `${o.categoria || "Categoria"}: ${this.moeda(o.valorPlanejado || 0)} / ${this.moeda(o.valorExecutado || 0)}`).join(" | ") : "Sem registros"],
          ["Métricas", (detalhe.metricas || []).length ? detalhe.metricas.map((m) => `${m.nome} (${m.valorAtual || 0}/${m.meta || 0})`).join(" | ") : "Sem registros"],
          ["Ações", this.normalizarAcoesProjeto(detalhe).length ? this.normalizarAcoesProjeto(detalhe).map((a) => `${a.titulo} (${a.percentualConclusao || 0}%)`).join(" | ") : "Sem registros"],
          ["Entregas/Tarefas", this.normalizarAcoesProjeto(detalhe).length ? this.normalizarAcoesProjeto(detalhe).map((a) => `${a.titulo}: ${(a.tarefas || []).length} tarefa(s)`).join(" | ") : "Sem registros"],
        ];
        autoTable(pdf, {
          startY: 52,
          head: [["Estrutura", "Detalhes"]],
          body: linhasDetalhe,
          styles: { fontSize: 8, overflow: "linebreak" },
          headStyles: { fillColor: [234, 88, 12], textColor: 255 },
          theme: "grid",
        });
      });

      pdf.save("bi-expandido-analitico.pdf");
    },
    carregarMock() {
      this.unidadesRegionais = [
        { id: 1, nome: "UR Norte" },
        { id: 2, nome: "UR Sul" },
      ];
      this.municipios = [
        { id: 10, nome: "São Luís", idUnidadeRegional: 1 },
        { id: 11, nome: "Imperatriz", idUnidadeRegional: 1 },
      ];
      this.pdms = [
        { idPdm: 1, idMunicipio: 10, nome: "PDM Inovação", status: "Ativo", periodoInicio: "2025-01-01", periodoFim: "2026-12-31" },
      ];
      this.pdmDetalhes = {
        1: {
          idPdm: 1,
          eixos: [
            {
              idEixo: 1001,
              nome: "Ambiente de Negócios",
              projetos: [{ idProjeto: 101 }],
            },
          ],
        },
      };
      this.projetos = [
        { idProjeto: 101, idPdm: 1, idMunicipio: 10, titulo: "Projeto Sala do Empreendedor", areaChave: "Ambiente de Negócios", situacao: "Planejamento", dataInicio: "2025-01-01", dataFim: "2026-12-31", orcamentoPlanejado: 100000, orcamentoExecutado: 62000, totalAcoes: 2 },
      ];
    },
  },
};
</script>

<style scoped>
.bi-publico {
  min-height: 100vh;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  background: #f3f5f8;
  color: #0f172a;
}
.card {
  background: #fff;
  border: 1px solid #d7e0eb;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.04);
}
.hero {
  background: linear-gradient(98deg, #0f2c66 0%, #3a46b8 48%, #d6652a 100%);
  color: #fff;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.eyebrow { text-transform: uppercase; letter-spacing: .08em; font-size: .75rem; margin: 0 0 6px; font-weight: 700; }
.hero h1 { margin: 0 0 6px; font-size: 2.3rem; }
.hero h1 span { color: #b9c8ff; }
.hero p { margin: 0; max-width: 780px; font-size: 1.05rem; }
.btn {
  border: none;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 700;
  background: #0b3b8a;
  color: #fff;
  cursor: pointer;
}
.btn:disabled { opacity: .6; cursor: not-allowed; }
.btn.ativo { background: #ea580c; }
.filtros {
  padding: 12px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 10px;
}
.campo { display: flex; flex-direction: column; gap: 5px; }
.campo label { font-size: .8rem; color: #334155; font-weight: 700; }
.campo select { min-height: 40px; border-radius: 8px; border: 1px solid #cbd5e1; padding: 6px; background:#fff; }
.cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 10px;
}
.kpi { padding: 12px; border-left: 5px solid #ea580c; }
.cards span { display: block; color: #64748b; font-size: .78rem; text-transform: uppercase; }
.cards strong { font-size: 2rem; color: #0f172a; line-height: 1.1; }
.insights-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.painel-status,.painel-eixos{padding:14px;}
.painel-status h3,.painel-eixos h3{margin:0 0 10px; color:#1e3a8a;}
.status-lista { display:grid; grid-template-columns:repeat(auto-fit, minmax(190px, 1fr)); gap:8px; }
.status-item { border:1px solid #e2e8f0; border-radius:10px; padding:8px; background:#f8fafc; }
.status-item p { margin:0; color:#475569; font-size:.8rem; }
.status-item strong { display:block; font-size:1.3rem; margin-top:2px; }
.status-item small { color:#0f766e; font-weight:700; }
.status-leitura { display:flex; flex-direction:column; gap:2px; margin-top:6px; color:#475569; font-size:.72rem; line-height:1.25; }
.eixo-item { margin-bottom:10px; }
.eixo-head { display:flex; justify-content:space-between; gap:8px; font-size:.85rem; font-weight:700; margin-bottom:4px; }
.barra { height:8px; border-radius:999px; background:#e2e8f0; overflow:hidden; }
.barra span { display:block; height:100%; background:linear-gradient(90deg,#1d4ed8,#34d399); border-radius:999px; }
.eixo-item small { color:#64748b; }

.btn-area-kpi {
  width: 100%;
  text-align: left;
  border: 1px solid #dbe4f0;
  border-radius: 10px;
  padding: 8px;
  background: #fff;
  cursor: pointer;
}
.okr-detalhe {
  margin-top: 8px;
  border-top: 1px dashed #cbd5e1;
  padding-top: 8px;
}
.okr-detalhe h4 { margin: 0 0 8px; color: #1e3a8a; }
.okr-vazio { color: #64748b; font-size: .88rem; margin: 0; }
.objetivo-item { margin-bottom: 8px; }
.btn-objetivo {
  border: 1px solid #cbd5e1;
  background: #f8fafc;
  border-radius: 8px;
  padding: 6px 8px;
  width: 100%;
  text-align: left;
  color: #0f172a;
  font-weight: 600;
  cursor: pointer;
}
.kr-lista { margin: 6px 0 0 18px; padding: 0; }
.kr-lista li { margin-bottom: 5px; color: #334155; }
.kr-lista span { display: block; color: #0f766e; font-size: .8rem; }
.bloco-projeto-inline { margin-top: 10px; padding: 10px; }
.painel-gantt { padding: 12px; }
.gantt-head { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-bottom: 8px; }
.gantt-head h3 { margin: 0; color: #1e3a8a; }
.gantt-wrap { display: flex; flex-direction: column; gap: 10px; }
.gantt-row { display: grid; grid-template-columns: 260px 1fr; gap: 10px; align-items: center; }
.gantt-label strong { display: block; font-size: .88rem; }
.gantt-label small { color: #64748b; font-size: .78rem; }
.gantt-track { position: relative; height: 26px; background: #e2e8f0; border-radius: 999px; overflow: hidden; }
.gantt-bar { position: absolute; top: 0; bottom: 0; border-radius: 999px; color: #fff; font-size: .72rem; font-weight: 700; display: flex; align-items: center; justify-content: center; padding: 0 6px; white-space: nowrap; }
.gantt-bar.planejado { background: #3b82f6; }
.gantt-bar.execucao { background: #f59e0b; }
.gantt-bar.concluido { background: #10b981; }
.gantt-alerta { grid-column: 2 / 3; color: #b45309; font-size: .78rem; }

.bi-quadro,.bloco-projetos,.bloco-projeto-detalhe { padding: 12px; }
.bi-quadro header { display: flex; justify-content: space-between; gap: 10px; flex-wrap: wrap; }
.acoes { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
.tabela-wrap { overflow: auto; }
table { width: 100%; border-collapse: collapse; }
th, td { border-bottom: 1px solid #e2e8f0; text-align: left; padding: 10px 8px; font-size: .87rem; }
th { background: #f1f5f9; color: #1e40af; text-transform: uppercase; font-size: .75rem; letter-spacing:.03em; }
.linha-pdm.selecionada { background: #e0ecff; font-weight: 700; border-left: 4px solid #ea580c; }
.link { border: none; background: transparent; color: #2563eb; font-weight: 700; cursor: pointer; padding: 0; text-align:left; }
.link.marcado { color: #c2410c; text-decoration: underline; }
.grupo-botoes { display: flex; flex-wrap: wrap; gap: 8px; margin: 10px 0; }
.painel-aba { background: #f8fafc; border-radius: 10px; padding: 10px; }
.acao-card { background: #fff; border: 1px solid #dbeafe; border-radius: 10px; padding: 8px; margin-bottom: 8px; }
.acao-card.selecionada { border-color: #ea580c; box-shadow: 0 0 0 2px rgba(234,88,12,.15); }
.entregas-lista { display: grid; gap: 8px; margin-top: 8px; }
.entrega-publica {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px;
  background: #f8fafc;
}
.entrega-publica.selecionada { border-color: #2563eb; box-shadow: 0 0 0 2px rgba(37,99,235,.14); }
.entrega-publica strong { display: block; color: #1e3a8a; margin-bottom: 4px; }
.entrega-publica ul { margin: 4px 0 0 18px; padding: 0; }
.entrega-publica li { cursor: pointer; margin-bottom: 4px; }
.entrega-publica li.selecionada { color: #c2410c; font-weight: 700; }
.entrega-publica small { color: #64748b; }
.area-box {
  border: 1px solid #d9e2ec;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  background: #fffcf0;
}
.area-box.selecionada { border-color: #ea580c; box-shadow: 0 0 0 2px rgba(234,88,12,.2); background: #fff7ed; }
.modal-pdf-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15,23,42,.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-pdf { background: #fff; border-radius: 12px; padding: 14px; min-width: 320px; border: 2px solid #0b3b8a; }
.modal-pdf h4 { margin: 0 0 6px; }
.radio { display: flex; gap: 8px; align-items: center; margin-bottom: 8px; }
.modal-acoes { display: flex; justify-content: flex-end; gap: 8px; }
.erro { background: #ffe4e6; color: #9f1239; border: 1px solid #fecdd3; border-radius: 8px; padding: 8px; margin: 0; }
@media (max-width: 980px){
  .hero { flex-direction:column; }
  .insights-grid { grid-template-columns:1fr; }
  .gantt-row { grid-template-columns: 1fr; }
  .gantt-alerta { grid-column: 1 / -1; }
}
</style>
